import React from 'react';

import logo from '../assets/logo.svg';

const Hero = () => (
  <div className="text-center hero my-5">
    <img className="mb-3 app-logo" src={logo} alt="LINQ logo" width="120" />
    <h1 className="mb-4">API Documentation</h1>

    <p className="lead">This is a centralized documentation site for Shared Service APIs.</p>
  </div>
);

export default Hero;
